import React from 'react';
import Icon from '../../../components/AppIcon';

const RedemptionModal = ({ reward, availableStars, onConfirm, onCancel }) => {
  const remainingAfter = availableStars - (reward?.starCost || 0);

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-br from-amber-400 to-orange-500 p-6 text-center">
          <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
            <Icon name={reward?.icon || 'Gift'} size={40} className="text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">{reward?.title}</h2>
          <p className="text-amber-100 text-sm mt-1">{reward?.description}</p>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="bg-amber-50 rounded-2xl p-4 mb-5">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm text-muted-foreground">Cost</span>
              <div className="flex items-center space-x-1">
                <span className="text-lg">⭐</span>
                <span className="font-bold text-amber-600 text-lg">{reward?.starCost}</span>
                <span className="text-sm text-muted-foreground">stars</span>
              </div>
            </div>
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm text-muted-foreground">Your balance</span>
              <div className="flex items-center space-x-1">
                <span className="text-lg">⭐</span>
                <span className="font-bold text-foreground">{availableStars}</span>
              </div>
            </div>
            <div className="h-px bg-amber-200 mb-3" />
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-foreground">After redemption</span>
              <div className="flex items-center space-x-1">
                <span className="text-lg">⭐</span>
                <span className={`font-bold text-lg ${remainingAfter >= 0 ? 'text-green-600' : 'text-red-500'}`}>
                  {remainingAfter}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 rounded-xl p-3 mb-5 flex items-start space-x-2">
            <Icon name="Info" size={16} className="text-blue-500 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-blue-700">
              Your teacher will be notified and will approve your reward request. Check back to see when it is approved!
            </p>
          </div>

          <div className="flex space-x-3">
            <button
              onClick={onCancel}
              className="flex-1 py-3 rounded-xl border-2 border-border text-foreground font-semibold hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-3 rounded-xl bg-amber-500 text-white font-semibold hover:bg-amber-600 transition-colors"
            >
              Confirm Redeem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedemptionModal;
